// https://stackoverflow.com/questions/54336173/vue-router-redirect-to-route-if-user-does-not-have-permissions

import Router from 'vue-router'
import Home from './views/Home'
import Dashboard from './views/Dashboard'

let router = new Router({
    mode:'history',
    routes:[
        {
            name:'index',
            path:'/',
            component:Home,
            meta:{
                userLoggedIn:false
            }
        },
        {
            name:'dashboard',
            path:'/dashboard',
            component:Dashboard,
            meta:{
                requiresAuth:true
            }
        },
        {
            name:'project',
            path:'/project/:projectId',
            component:Dashboard,
            meta:{
                requiresAuth:true
            }
        },
        {
            path:'*',
            redirect:'/'
        }
    ]
})

router.beforeEach((to, from, next) => {
    // cheick if authorization needed to view the page
    if(to.matched.some(record => record.meta.requiresAuth)){
        if(!localStorage.getItem('token')){
            next({
                path:'/',
                params: { nextUrl:to.fullPath }
            })
        } else {
            next()
        }
        console.log('handle auth')
    // authorization status handling
    } else if(!to.matched.some(record => record.meta.userLoggedIn)){
        console.log('check auth')
        next()
    } else {
        console.log('free pass')
        next()
    }
})

export default router